export const typeOfId = {
    'USER': 'USER',
    'GROUP' : 'GROUP'
};
